var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyBookingPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10233_55019)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 8,
    height: 8,
    fill: "#5D89EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 42C30.4 43.6 19.3333 41.3333 14 40L20 28L24 24H28H34V30C34 33.3333 33.6 40.4 32 42Z",
    fill: "#5D89EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 4.66797C37.1823 4.66775 39.321 5.27965 41.173 6.43414C43.0249 7.58864 44.516 9.23943 45.4766 11.199L45.696 11.668H49C49.3952 11.6679 49.784 11.7683 50.1299 11.9597C50.4757 12.1511 50.7673 12.4272 50.9772 12.7622C51.1871 13.0971 51.3085 13.4799 51.33 13.8745C51.3514 14.2692 51.2723 14.6629 51.1 15.0186L50.9413 15.2963L47.32 20.726C47.0423 21.1434 46.9065 21.6393 46.9326 22.14L46.9653 22.4386L47.2943 24.2446C49.602 36.9333 40.0423 48.6303 27.244 48.992L26.6326 49.0013H6.99996C6.60469 49.0013 6.21589 48.9009 5.87004 48.7095C5.5242 48.5181 5.23264 48.242 5.02272 47.9071C4.81281 47.5722 4.69142 47.1894 4.66995 46.7947C4.64848 46.4 4.72762 46.0064 4.89996 45.6506L5.05863 45.373L22.4303 19.3143C23.0191 18.4321 23.3333 17.3953 23.3333 16.3346C23.3333 13.2404 24.5625 10.273 26.7504 8.08506C28.9383 5.89713 31.9058 4.66797 35 4.66797ZM26.8333 25.668C26.201 25.668 25.2863 25.8313 24.416 26.1556C23.541 26.4823 23.058 26.844 22.89 27.0376L14.994 38.884C17.3226 38.2143 19.8123 37.477 22.141 36.5646C24.6306 35.5916 26.7563 34.4833 28.2286 33.1906C29.6566 31.9376 30.3333 30.6426 30.3333 29.168C30.3333 28.2397 29.9645 27.3495 29.3082 26.6931C28.6518 26.0367 27.7616 25.668 26.8333 25.668ZM35 14.0013C34.3811 14.0013 33.7876 14.2471 33.35 14.6847C32.9125 15.1223 32.6666 15.7158 32.6666 16.3346C32.6666 16.9535 32.9125 17.547 33.35 17.9846C33.7876 18.4221 34.3811 18.668 35 18.668C35.6188 18.668 36.2123 18.4221 36.6499 17.9846C37.0875 17.547 37.3333 16.9535 37.3333 16.3346C37.3333 15.7158 37.0875 15.1223 36.6499 14.6847C36.2123 14.2471 35.6188 14.0013 35 14.0013Z",
    fill: "#B3D5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10233_55019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyBookingPromotion);
export default __webpack_public_path__ + "static/media/early-booking-promotion.eba8e740.svg";
export { ForwardRef as ReactComponent };